// Polyfills
import 'es6-promise/auto';  // needed for polyfill loading

import(
  /* webpackChunkName: "polyfills" */
  'respimage'
);
// import 'whatwg-fetch';
// import 'cq-prolyfill';

// import './generic/privacy';

// Components

// import './patternlab/patterns/blocks/privacysettings/privacysettings';
import './components/base/video/video';
// import './components/blocks/gallery/gallery';
import './components/blocks/slider/slider';
import './components/blocks/slider/product/product';
import './components/blocks/slider/customerreview/customerreview';

// Objects

// import './js/countup/countup.js';

// import './interactive/aos/aos.js';
import './interactive/lightbox/lightbox.js';
import './interactive/tooltip/tooltip.js';
import './interactive/ecommerce/ecommerce.js';
// import './interactive/typed/typed.js';
